/* src/app/components/user/third-party/third-party-open-ai/third-party-open-ai.component.scss */
.app-container {
  max-width: 425px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 1px 2px #e0e0e0;
}
.flex--column {
  --flex: 1;
}
:host-context(.dark-theme) .app-container {
  border: 1px solid transparent;
  box-shadow: 1px 2px 3px 2px rgba(0, 0, 0, 0.12);
  background: #464646;
}
/*# sourceMappingURL=third-party-open-ai.component.css.map */
